"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const controller_1 = require("./fileinput/controller");
const hasMaxFiles_1 = require("./fileinput/hasMaxFiles");
const fileCounter_1 = require("./fileinput/fileCounter");
const isEmpty_1 = require("./fileinput/isEmpty");
const notice_1 = __importDefault(require("./fileinput/notice"));
const maxFileSize_1 = require("./fileinput/maxFileSize");
const dropzone_1 = require("./fileinput/dropzone");
const fileList_1 = __importDefault(require("./fileinput/UI/fileList"));
const filePreviewFactory_1 = __importDefault(require("./fileinput/UI/preview/filePreviewFactory"));
const fileInputButtonHandler_1 = __importDefault(require("./fileinput/UI/fileInputButtonHandler"));
class FileInput {
    constructor() {
        this.initFileInputs();
    }
    initFileInputs() {
        document.querySelectorAll('[data-js-file="dropzone"]').forEach((dropzone) => {
            const [input, button, listArea, template] = this.getElementsFromDropzone(dropzone);
            if (!(input && button && listArea && template)) {
                console.error('FileInput: Missing required elements in dropzone.');
                return;
            }
            const controller = new controller_1.FileInputController(input);
            if (dropzone) {
                //Main functionality
                const noticeHandler = new notice_1.default(dropzone);
                new fileList_1.default(controller, filePreviewFactory_1.default.createFilePreviewRenderer(controller, dropzone, listArea, template)).init();
                new fileInputButtonHandler_1.default(input, button).init();
                new dropzone_1.Dropzone(dropzone, noticeHandler, input);
                //Detached event listeners
                (0, maxFileSize_1.MaxFileSize)(controller, dropzone, noticeHandler);
                (0, hasMaxFiles_1.HasMaxFiles)(controller, dropzone);
                (0, fileCounter_1.FileCounter)(controller, dropzone);
                (0, isEmpty_1.FileInputisEmpty)(controller, dropzone);
            }
        });
    }
    getElementsFromDropzone(dropzone) {
        const input = dropzone.querySelector('[data-js-file="input"]');
        const button = dropzone.querySelector('[data-js-file="button"]');
        const listArea = dropzone.querySelector('[data-js-file="list"]');
        const template = dropzone.querySelector('[data-js-file="listitem-template"]');
        return [input, button, listArea, template];
    }
}
exports.default = FileInput;
